module.exports = "/assets/data/98091874b1bef906dd8b598637820f4f-W1S.data.json";